

<div class="snackbar-body">
  <div class="message-body" style="margin: 6%">
    {{data.message}}
  </div>
  <button mat-icon-button (click)="close()">
    <mat-icon class="close-button" color="warn" style="color:  rgb(192, 199, 196);">cancel</mat-icon>
  </button>
</div>

  
  <!-- <button mat-stroked-button (click)="openSnackBar(message.value)">Show snack-bar</button> -->